import { render, staticRenderFns } from "./ModalDebtsBillFormComponent.vue?vue&type=template&id=2a06c45d&scoped=true"
import script from "./ModalDebtsBillFormComponent.vue?vue&type=script&lang=js"
export * from "./ModalDebtsBillFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDebtsBillFormComponent.vue?vue&type=style&index=0&id=2a06c45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06c45d",
  null
  
)

export default component.exports